/* Loupe – shop the look: hotspots highlight their product row; click opens a quick-add panel. */
(() => {
  if (customElements.get('loupe-look')) return;
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  class LoupeLook extends HTMLElement {
    connectedCallback() {
      this.dots = [...this.querySelectorAll('[data-look-dot]')];
      this.items = [...this.querySelectorAll('[data-look-item]')];
      this.pops = [...this.querySelectorAll('[data-look-pop]')];
      this.list = this.querySelector('[data-look-list]');
      this.current = -1;
      const idx = (el) => Number(el.dataset.index);

      this.dots.forEach((d) => {
        d.addEventListener('mouseenter', () => this.highlight(idx(d)));
        d.addEventListener('focus', () => this.highlight(idx(d)));
        d.addEventListener('click', () => (this.current === idx(d) ? this.close() : this.show(idx(d), true)));
      });
      this.items.forEach((it) => {
        it.addEventListener('mouseenter', () => this.highlight(idx(it)));
        it.addEventListener('focusin', () => this.highlight(idx(it)));
      });
      this.addEventListener('mouseleave', () => this.highlight(this.current));
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.highlight(this.current); });
      this.addEventListener('click', (e) => { if (e.target.closest('[data-look-close]')) this.close(true); });
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.current > -1) { e.stopPropagation(); this.close(true); } });

      this.onDoc = (e) => { if (this.current > -1 && !e.target.closest('[data-look-pop],[data-look-dot]')) this.close(); };
      document.addEventListener('click', this.onDoc);

      /* theme editor: selecting a hotspot block opens its panel */
      this.onSelect = (e) => {
        const it = this.items.find((x) => x === e.target);
        if (!it) return;
        if (e.type === 'shopify:block:select') this.show(idx(it), false); else this.close();
      };
      document.addEventListener('shopify:block:select', this.onSelect);
      document.addEventListener('shopify:block:deselect', this.onSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDoc);
      document.removeEventListener('shopify:block:select', this.onSelect);
      document.removeEventListener('shopify:block:deselect', this.onSelect);
    }

    at(list, i) { return list.find((x) => Number(x.dataset.index) === i); }

    highlight(i) {
      this.classList.toggle('has-active', i > -1);
      this.dots.forEach((d) => d.classList.toggle('is-active', Number(d.dataset.index) === i));
      this.items.forEach((it) => it.classList.toggle('is-active', Number(it.dataset.index) === i));
    }

    show(i, focus) {
      if (this.current > -1) this.close();
      const pop = this.at(this.pops, i); const dot = this.at(this.dots, i);
      if (!pop || !dot) return;
      this.current = i;
      pop.hidden = false;
      dot.setAttribute('aria-expanded', 'true');
      this.highlight(i);
      this.reveal(i);
      if (focus) requestAnimationFrame(() => pop.focus({ preventScroll: true }));
    }

    close(refocus) {
      if (this.current < 0) return;
      const pop = this.at(this.pops, this.current); const dot = this.at(this.dots, this.current);
      this.current = -1;
      if (pop) pop.hidden = true;
      if (dot) { dot.setAttribute('aria-expanded', 'false'); if (refocus) dot.focus({ preventScroll: true }); }
      this.highlight(-1);
    }

    /* mobile: bring the matching product into view inside the horizontal list (no page scroll) */
    reveal(i) {
      const it = this.at(this.items, i); const l = this.list;
      if (!it || !l || l.scrollWidth <= l.clientWidth + 1) return;
      const left = it.offsetLeft - (l.clientWidth - it.offsetWidth) / 2;
      l.scrollTo({ left: Math.max(0, left), behavior: reduced() ? 'auto' : 'smooth' });
    }
  }
  customElements.define('loupe-look', LoupeLook);
})();
